import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
    JobFeatureDetailType,
    JobLayerDetail
} from 'src/app/shared/map-data-services/feature/job-feature-cache.service';
import { LayerStyleGenerator } from 'src/app/shared/map-data-services/layer/layer-style-generator';

export interface AccordionAction {
    id: string;
    title: string;
    icon?: string;
    tooltipKey?: string;
}

export class JobLayerListActionsProvider {
    static getActions(): AccordionAction[] {
        return [
            { id: 'selectAll', title: 'Common.SelectAll' },
            { id: 'zoom', title: '', icon: 'window_resize', tooltipKey: 'TC.Common.ZoomToFeatures' }
        ];
    }
}

@Component({
    selector: 'job-layer-list',
    templateUrl: './job-layer-list.component.html'
})
export class JobLayerListComponent {
    @Input() jobFeatureDetails: JobFeatureDetailType | null = null;
    @Output() selectAllFeatures = new EventEmitter<void>();
    @Output() zoomToFeatures = new EventEmitter<void>();

    accordionActions: AccordionAction[] = JobLayerListActionsProvider.getActions();

    get isFeaturesAvailable(): boolean {
        return !!this.jobFeatureDetails?.layers && this.jobFeatureDetails.layers.length > 0;
    }

    getOutlineColorFromStyle(layer: JobLayerDetail) {
        return LayerStyleGenerator.getOutlineColorFromStyle(layer.style, layer.geomType);
    }

    onActionClick(action: AccordionAction): void {
        switch (action.id) {
            case 'selectAll':
                this.selectAllFeatures.emit();
                break;
            case 'zoom':
                this.zoomToFeatures.emit();
                break;
        }
    }
}
